import React, { memo } from "react";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import SideMenuUi from "./SideMenu.ui";

export const SideMenu: React.FunctionComponent<{ currentViewName: any }> = ({
  currentViewName,
}) => {
  return (
    <>
      <SideMenuUi currentViewName={currentViewName} />
    </>
  );
};
